import { React, useState, useContext } from 'react';
import { AppContext } from '../../services/AppContext';
import { useTranslation } from 'react-i18next';

const CreateManager = ({ closeModal }) => {
    const { t } = useTranslation();
    const { apiClient, notify } = useContext(AppContext);
    const [newManager, setNewManager] = useState({ name: '', username: '', role: 1, profitShare: 40 });

    const handleSaveManager = async () => {

        if (!newManager.name || !newManager.username) {
            notify(t('error.fillAllFields'), 'error');
            return;
        }

        const formData = new FormData();
        formData.append('name', newManager.name);
        formData.append('username', newManager.username);
        formData.append('role', newManager.role);
        formData.append('profitShare', newManager.profitShare);

        const result = await apiClient.createUser(formData);

        if (result.hasErrors) return;
        
        closeModal(true);

        notify(t('pages.managers.notifications.managerCreated'), 'success');
        setNewManager({ name: '', username: '', role: 1, profitShare: 40 });
    };

    const handleCancel = () => {
        setNewManager({});
        closeModal(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewManager((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <h3>{t('pages.managers.addNewManager')}</h3>
                <input
                    type="text"
                    name="name"
                    placeholder={t('pages.managers.placeholders.name')}
                    value={newManager.name}
                    onChange={handleChange}
                />
                <input
                    type="text"
                    name="username"
                    placeholder={t('pages.managers.placeholders.username')}
                    value={newManager.username}
                    onChange={handleChange}
                />

                <div className="container">
                    <button className="mg-r-1 width-100p" onClick={handleSaveManager}>
                        {t('pages.managers.actions.save')}
                    </button>
                    <button className="width-100p" onClick={handleCancel}>
                        {t('pages.managers.actions.cancel')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateManager;